import { Component } from '@angular/core';

@Component({
  selector: 'app-block-footer',
  imports: [],
  templateUrl: './footer.html',
  standalone: true,
  styleUrl: './footer.scss'
})
export class FooterBlock {

}
